import { ComponentsProps } from '@mui/material/styles/props';
import { ComponentsOverrides } from '@mui/material/styles/overrides';
import { Theme } from '@mui/material';
import { ComponentsVariants } from '@mui/material/styles/variants';

export const muiDrawer: {
    defaultProps?: ComponentsProps['MuiDrawer'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiDrawer'];
    variants?: ComponentsVariants['MuiDrawer'];
} = {
    styleOverrides: {
        root: {
            '&.hide-backdrop': {
                '.MuiBackdrop-root': {
                    background: 'none',
                },
                '.MuiPaper-root': {
                    boxShadow: '2px -5px 15px -7px rgba(0,0,0,0.53)',
                },
            },
        },
        paper: {
            maxHeight: '85%',
        },
        paperAnchorBottom: {
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            paddingTop: 16,
            paddingBottom: 0,
        },
    },
};

export const muiBackdrop: {
    defaultProps?: ComponentsProps['MuiBackdrop'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiBackdrop'];
    variants?: ComponentsVariants['MuiBackdrop'];
} = {};
